import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showSnackBar } from "../../redux/action/snackActions";
import SmartTable from "../../components/common/SmartTable";

import DeleteModal from "../../components/common/Modals/DeleteModal";
import EditCommonAction from "../../components/common/Actions/EditAction";

import CommonConfirmModal from "../../components/common/Modals/CommonConfirmModal";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment-timezone";
import { DATEFORMAT, dateRanges } from "../../contants";
import {
  editOrder,
  getPreviosOrders,
  setOrderToEdit,
  updateOrder,
} from "../../redux/action/orderActions";
import { useNavigate } from "react-router-dom";
import EditOrderModal from "../../components/common/Modals/EditOrderModal";
import ViewCommonAction from "../../components/common/Actions/ViewCommonAction";

import { setPrintData } from "../../redux/action/utilActions";
import { uuid } from "uuidv4";
import { getAllBranches } from "../../redux/action/branchActions";

const PageTitle = "Order History";

const OrderHistory = () => {
  const navigate = useNavigate();
  const { previousOrders, activeOrders } = useSelector((state) => state.order);
  const { role, restaurantId, branchId, actionLockSetting } = useSelector((state) => state.user);
  const [open, setOpen] = React.useState();

  const branches = useSelector((state) => state.branch.allBranches);
  const [selectedBranch, setSelectedBranch] = React.useState(branchId);

  const currBranchId = branchId || selectedBranch;
  const isRestaurantAdmin = ["restaurantadmin"].includes(role);
  const isBranchAdmin = ["branchadmin"].includes(role);
  const isSuperAdmin = ["superadmin"].includes(role);

  const getAllData = () => {
    if (isRestaurantAdmin) {
      dispatch(getPreviosOrders({ ...state, start: moment(state.start, DATEFORMAT).format("YYYY-MM-DD"), end: moment(state.end, DATEFORMAT).format("YYYY-MM-DD"), branchId: currBranchId }));
      dispatch(getAllBranches(restaurantId, true));
    }
    if (isBranchAdmin) {
      dispatch(getPreviosOrders({ ...state, start: moment(state.start, DATEFORMAT).format("YYYY-MM-DD"), end: moment(state.end, DATEFORMAT).format("YYYY-MM-DD"), branchId: currBranchId }));
    }
  };

  const dispatch = useDispatch();

  const [actionData, setActionData] = React.useState();

  const [state, setState] = React.useState({
    start: dateRanges.Today[0],
    end: dateRanges.Today[1],
  });
  const { start, end } = state;

  const handleCallback = (start, end) => {
    // props.setValue({ start, end });
    // onChange(setState({ start, end }));
    setState({ start: start.format(DATEFORMAT), end: end.format(DATEFORMAT) });
  };

  const handlePrint = (data) => {
    dispatch(setPrintData({ ...data, printId: uuid() }));
  };

  const toggleAdd = (mode) => {
    if (mode === undefined) {
      setActionData({});
    }
    setOpen(mode);
  };

  const handleEdit = (data, mode) => {
    // delete data.orderItems;

    toggleAdd(mode || "EditOrder");
    setActionData(data);
  };

  const handleUpdateOrder = (data) => {
    dispatch(
      editOrder(
        {
          ...data,

          grandTotal: Math.ceil(data.grandTotal),
          orderItems: data.orderItems,
        },
        () => {
          toggleAdd();
          getAllData();
        },
        () => {},
        "Order Updated",
        "Failed To Update Order"
      )
    );
  };

  const EditAction = (action) => {
    const isEdited = action.data?.isEdited;
    return (
      !isEdited && (
        <EditCommonAction
          onClick={() => {
            handleEdit(action.data, "EditOrder");
          }}
        />
      )
    );
  };
  const ViewAction = (action) => (
    <ViewCommonAction onClick={() => handleEdit(action.data, "View")} />
  );

  const headers = [
    {
      title: "Order Number",
      key: "branchOrderNumber",

      renderRow: (child) => (
        <>
          {child.branchOrderNumber}
          {child.isEdited && (
            <div className="badge badge-orange ml-2">Edited</div>
          )}
        </>
      ),
    },
    {
      title: "Items",
      key: "itemsLength",
      renderRow: (child) => child.orderItems.length,
    },

    { title: "SGST", key: "sgstCharges", isCurrency: true },
    { title: "CGST", key: "cgstCharges", isCurrency: true },
    { title: "Discount", key: "discount", isCurrency: true },

    { title: "Other Charges", key: "otherCharges", isCurrency: true },
    { title: "Payment Type", key: "paymentType", isCurrency: true },
    { 
      title: "Amount", 
      key: "grandTotal", 
      isCurrency: true,
      renderRow: (child) => (
        <>
          {child.grandTotal}
          <div className={`badge badge-${child.isPaid ? 'success' : 'warning'} ml-2`}>
            {child.isPaid ? 'Paid' : 'Confirmed'}
          </div>
        </>
      )
    },
  ];

  const defaultValues = {
    // restaurantId: restaurantId,
  };

  React.useEffect(() => {
    getAllData();
  }, [selectedBranch, state]);

  const DatePicker = (action) => (
    <div className="">
      <DateRangePicker
        initialSettings={{
          startDate: start,
          endDate: end,

          locale: {
            format: DATEFORMAT,
          },
          maxDate: new Date(),

          ranges: dateRanges,
        }}
        onCallback={handleCallback}
      >
        <input type="text" className="form-control" />
      </DateRangePicker>
    </div>
  );

  const BranchFilter = (action) => (
    <div className="">
      <select
        name="status"
        className="form-control"
        defaultValue="true"
        required
        value={selectedBranch}
        onChange={(e) => setSelectedBranch(e.target.value)}
      >
        <option value={""} selected>
          This restaurant
        </option>
        {branches.map((res, resindex) => {
          return (
            <option key={resindex} value={res._id}>
              {res.branchName}
            </option>
          );
        })}
      </select>
    </div>
  );

  const headerComponents = {
    restaurantadmin: [BranchFilter, DatePicker],
    branchadmin: [DatePicker],
  };

  const showEditModal =
    actionData?.refId || open === "EditOrder" || open === "View";
  return (
    <>
      <div className="page-content-tab">
        {/* <CommonConfirmModal
          size="md"
          open={open === "Edit"}
          title={"Please complete all active orders before editing."}
          onClose={() => toggleAdd()}
          onConfirm={() => handleEditConfirm()}
        /> */}
        {showEditModal && (
          <EditOrderModal
            data={actionData}
            open={showEditModal}
            mode={open}
            onClose={() => toggleAdd()}
            onSubmit={(data) => handleUpdateOrder(data)}
            onPrint={(data) => handlePrint(data)}
          />
        )}

        <SmartTable
          headerComponents={headerComponents[role]}
          title={PageTitle}
          searchByLabel="Order Number"
          searchByField="branchOrderNumber"
          // headActions={[AddAction]}
          actions={actionLockSetting ? [] : [...(branchId && state.start === moment.tz("Asia/Kolkata").utc(true).format(DATEFORMAT) ? [EditAction] : []), ViewAction]}
          tableData={previousOrders}
          headers={headers}
          sortable={true}
          paginated={true}
          rowsPerPage={5}
        />
      </div>
    </>
  );
};

export default OrderHistory;
